import Vue from 'vue'
import VueRouter from 'vue-router'
import Species from '../views/SingleSpecies.vue'
import miljoRoutes from './miljoRoutes.js'
import factsRoutes from './factsRoutes.js'
import miscRoutes from './miscRoutes.js'
import catchRoutes from './catchRoutes.js'
import IntroVideo from '@/views/Video'

import $store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
    meta: { scrollTop: true },
    children: [
      {
        path: '/intro-video',
        name: 'Video',
        component: IntroVideo,
        meta: { scrollTop: true }
      }
    ]
  },

  {
    path: '/art/:nameUrl',
    name: 'SingleSpecies',
    props: true,
    component: Species,
    meta: { scrollTop: true }
  },
  {
    path: '/arter',
    name: 'Species',
    component: () =>
      import(/* webpackChunkName: "arter" */ '../views/AllSpecies.vue')
  },
  {
    path: '/arter/frammande-arter',
    name: 'AlienSpecies',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "alien_species" */ '../views/AlienSpecies.vue'
      ),
    meta: { scrollTop: true }
  },
  {
    path: '/arter/rodlistade-arter',
    name: 'RedSpecies',
    props: true,
    component: () =>
      import(/* webpackChunkName: "red_species" */ '../views/RedSpecies.vue'),
    meta: { scrollTop: true }
  },
  {
    path: '/arter/:categoryNameUrl',
    name: 'SpeciesCategory',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "arter_category" */ '../views/CategorySpecies.vue'
      )
  },
  {
    path: '/arter/:categoryNameUrl/:subCategoryNameUrl',
    name: 'SpeciesSubCategory',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "arter_category_subcategory" */ '../views/CategorySpecies.vue'
      )
  },
  {
    path: '/search',
    name: 'Search',
    props: route => ({ query: route.query.q }),
    component: () =>
      import(/* webpackChunkName: "search" */ '../views/Search.vue')
  }
]

routes.push(...miljoRoutes)
routes.push(...factsRoutes)
routes.push(...miscRoutes)
routes.push(...catchRoutes)

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_METHOD,
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.scrollTop) {
    window.scrollTo(0, 0)
    next()
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.query && to.query.area) {
    $store.dispatch('setGeneralArea', to.query.area)
  }
  next()
})

export default router
